export default {
  large: 'medium',
  medium: 'small',
  small: 'tiny',
}
